/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorInfoModelSchema } from "../authorInfoModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAuthorsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор автора.")
    })

/**
 * @description Модель автора
 */
export const getApiAuthorsId200Schema = z.lazy(() => authorInfoModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAuthorsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAuthorsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAuthorsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Автор не найден
 */
export const getApiAuthorsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAuthorsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAuthorsIdQueryResponseSchema = z.lazy(() => getApiAuthorsId200Schema)